import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import AccountReceivablesView from "./account-receivables";
import OrderViews from "../../common/orders";
import useAccessLevels from "../../../../hooks/use-access-levels";
import AccountingOnlinePaymentTransactionsView from "./online-payment-transactions";

const AccountingViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Checks the pathname of the url with each change of the url.
     * if the pathname was [accounting.base] then redirects the user to the credits view.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.accounting.base, exact: true})) {
            if (operatorAccessLevels.packages.sales.invoicesList) {
                history.replace(routes.accounting.invoices);
            } else if (operatorAccessLevels.packages.sales.accountReceivables) {
                history.replace(routes.accounting.accountReceivable);
            } else if (operatorAccessLevels.packages.sales.onlinePaymentTransactionHistory) {
                history.replace(routes.accounting.onlinePaymentTransactions);
            } else {
                history.replace(routes.accounting.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.sales.accountReceivables, operatorAccessLevels.packages.sales.invoicesList, operatorAccessLevels.packages.sales.onlinePaymentTransactionHistory])

    return (
        <>
            <Switch>
                <Route path={routes.accounting.base} exact/>
                {
                    operatorAccessLevels.packages.sales.invoicesList &&
                    <Route path={routes.accounting.invoices} exact>
                        <OrderViews allowPayments={true}/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.onlinePaymentTransactionHistory &&
                    <Route path={routes.accounting.onlinePaymentTransactions} exact>
                        <AccountingOnlinePaymentTransactionsView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.accountReceivables &&
                    <Route path={[routes.accounting.accountReceivable]} exact>
                        <AccountReceivablesView/>
                    </Route>
                }
                <Redirect to={routes.accounting.base.concat(routes.error.accessDeniedForSection)}/>
            </Switch>
        </>

    );
};

export default AccountingViews;
